import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestData } from 'src/app/common/models/request-data.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HotItemDisplayOrderService {

  constructor(private http: HttpClient) { }

  getHotItemDisplayOrderByMenuId(hotItemId: number): Observable<any> {
    // Replace with your actual API endpoint
    return this.http.get(environment.baseUrl + '/hot-item-display-order/get/' + hotItemId);
  }
  /**
     * 
     * @param reasonsInfo 
     * Calls the update API to insert/update the record
     */
     update(itemClassInfo:any): Observable<any> { 
        return this.http.post(environment.baseUrl+'/hot-item-display-order/update', itemClassInfo);

    }
}
